import React from 'react';
import WorkExperience from '../../components/workShowCase/Index';

function Index() {
  return (
    <>
      <WorkExperience />
    </>
  );
}

export default Index;